export const GET_INVESTMENT_ATTEMPT = 'GET_INVESTMENT_ATTEMPT';
export type GET_INVESTMENT_ATTEMPT = typeof GET_INVESTMENT_ATTEMPT;

export const GET_INVESTMENT_SUCCESS = 'GET_INVESTMENT_SUCCESS';
export type GET_INVESTMENT_SUCCESS = typeof GET_INVESTMENT_SUCCESS;

export const GET_INVESTMENT_FAILURE = 'GET_INVESTMENT_FAILURE';
export type GET_INVESTMENT_FAILURE = typeof GET_INVESTMENT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/investment/get/Types.tsx